// frontend/src/services/commands/GenericCommandService.js
import { CommandService } from './CommandService.js';

/**
 * Serwis komend ogólnych - dostępnych dla wszystkich typów urządzeń
 */
export class GenericCommandService extends CommandService {
  constructor(apiClient) {
    super(apiClient);
    this.basePath = '/devices';
  }

  /**
   * Wykonaj komendę asynchronicznie na dowolnym urządzeniu
   */
  async executeCommandAsync(deviceUuid, command, data, timeout) {
    return this.apiClient.post(`${this.basePath}/${deviceUuid}/execute/`, {
      command,
      data,
      timeout,
      async: true
    });
  }

  /**
   * Wykonaj komendę synchronicznie na dowolnym urządzeniu
   */
  async executeCommandSync(deviceUuid, command, data, timeout) {
    return this.apiClient.post(`${this.basePath}/${deviceUuid}/execute/`, {
      command,
      data,
      timeout,
      async: false
    });
  }

  // === BASIC DEVICE COMMANDS ===
  
  /**
   * Ping urządzenia - sprawdź czy odpowiada
   */
  async ping(deviceUuid, options = {}) {
    return this.executeCommand(deviceUuid, 'ping', {}, options);
  }

  /**
   * Pobierz informacje o urządzeniu
   */
  async getDeviceInfo(deviceUuid, options = {}) {
    return this.executeCommand(deviceUuid, 'get_device_info', {}, options);
  }

  /**
   * Sprawdź status połączenia
   */
  async getConnectionStatus(deviceUuid, options = {}) {
    return this.executeCommand(deviceUuid, 'get_connection_status', {}, options);
  }

  /**
   * Restartuj urządzenie
   */
  async reboot(deviceUuid, options = {}) {
    return this.executeCommand(deviceUuid, 'reboot', {}, options);
  }

  // === AUTHENTICATION COMMANDS ===
  
  /**
   * Odnów token autoryzacyjny
   */
  async refreshAuth(deviceUuid, options = {}) {
    return this.executeCommand(deviceUuid, 'refresh_auth', {}, options);
  }

  /**
   * Sprawdź status autoryzacji
   */
  async checkAuthStatus(deviceUuid, options = {}) {
    return this.executeCommand(deviceUuid, 'check_auth_status', {}, options);
  }

  // === TIME SYNC COMMANDS ===
  
  /**
   * Synchronizuj czas z serwerem
   */
  async syncTime(deviceUuid, options = {}) {
    return this.executeCommand(deviceUuid, 'sync_time', {}, options);
  }

  /**
   * Pobierz czas z urządzenia
   */
  async getDeviceTime(deviceUuid, options = {}) {
    return this.executeCommand(deviceUuid, 'get_device_time', {}, options);
  }
}
